import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCropperModule } from 'ngx-image-cropper';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { ProfileComponent } from './profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardBannerComponent } from './components/dashboard-banner/dashboard-banner.component';
import { DashboardProgramComponent } from './components/dashboard-program/dashboard-program.component';
import { DashboardComponent } from './container/dashboard/dashboard.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProgramFeedbackComponent } from './container/program-feedback/program-feedback.component';
import { ProgramCompletionComponent } from './container/program-completion/program-completion.component';
import { ProgramCertificateComponent } from './container/program-certificate/program-certificate.component';
import { ClipboardModule } from 'ngx-clipboard';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { DashboardBannerNewComponent } from './components/dashboard-banner-new/dashboard-banner-new.component';
import { DashboardProgramNewComponent } from './components/dashboard-program-new/dashboard-program-new.component';
import { CourseLevelFeedbackFormComponent } from './container/dashboard/course-level-feedback-form/course-level-feedback-form.component';
import { ProgramCompletionModalComponent } from './components/program-completion-modal/program-completion-modal.component';
import { HirationComponent } from './components/hiration/hiration.component';
import { TimezoneConfirmationModalComponent } from './components/timezone-confirmation-modal/timezone-confirmation-modal.component';
import { CertificateShareComponent } from './container/certificate-share/certificate-share.component';
import { PartnerTermConditionPopupComponent } from './components/partner-term-condition-popup/partner-term-condition-popup.component';
import { AccordionModule, AccordionConfig } from 'ngx-bootstrap/accordion';
@NgModule({
  declarations: [DashboardComponent, ProfileComponent, DashboardBannerComponent, DashboardProgramComponent, ProgramFeedbackComponent, ProgramCompletionComponent, ProgramCertificateComponent, DashboardBannerNewComponent, DashboardProgramNewComponent, CourseLevelFeedbackFormComponent, ProgramCompletionModalComponent, HirationComponent, TimezoneConfirmationModalComponent, CertificateShareComponent, PartnerTermConditionPopupComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
    SharedModule,
    ClipboardModule,
    NgCircleProgressModule.forRoot({
      "radius": 25,
      "space": -2,
      "unitsColor": "#f47920",
      "titleColor": "#f47920",
      "outerStrokeWidth": 2,
      "outerStrokeColor": "#f47920",
      "innerStrokeColor": "#f0ccb9",
      "innerStrokeWidth": 2,
      // "title": "UI",
      "titleFontSize": "14",
      "subtitleFontSize": "14",
      "animateTitle": false,
      "animationDuration": 1000,
      "showTitle": true,
      "showUnits": true,
      "unitsFontSize": "14",
      "showBackground": false,
      "clockwise": true,
      "startFromZero": true,
      "showSubtitle": false,
    }),
    AccordionModule
  ]
})
export class DashboardModule { }
